export const state = {
	featureFlags: null
}

export const getters = {
  featureFlags: state => {
    return state.featureFlags;
  },
}

export const mutations = {
  SET_FLAGS(state, data){
    state.featureFlags = data;
  },
}

export const actions = {
	setFlags({ commit }, data){
		commit("SET_FLAGS", data);
	}
}